import React from 'react';

import { makeStyles, Theme } from '@material-ui/core/styles';
import clsx from 'clsx';

import { Typography } from '../../atoms/Typography/Typography';

const useStyles = makeStyles((theme: Theme) => ({
  actionDiv: {
    alignItems: 'center',
    display: 'flex',
    flex: 1,
    justifyContent: 'flex-end',
    marginRight: theme.spacing(3),
  },
  root: {
    background: theme.palette.grey[200],
    display: 'flex',
    flex: 1,
    flexDirection: 'row',
  },
  textDiv: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    padding: theme.spacing(2),
  },
  title: {
    marginBottom: theme.spacing(1),
  },
}));

export type Props = {
  action?: JSX.Element;
  className?: string;
  subTitle?: string;
  title: string;
};

export function InfoBox(props: Props): JSX.Element {
  const { action, className, subTitle, title } = props;
  const classes = useStyles();
  const containerStyles = clsx(classes.root, className || '');
  return (
    <div className={containerStyles}>
      <div className={classes.textDiv}>
        <Typography className={classes.title} variant="h3">
          {title}
        </Typography>
        {subTitle && (
          <Typography data-fd="sub-title" variant="caption">
            {subTitle}
          </Typography>
        )}
      </div>
      {action && (
        <div className={classes.actionDiv} data-fd="action">
          {action}
        </div>
      )}
    </div>
  );
}
